import {Grid} from "@leap4/frontend";
import {Route, Switch} from "react-router-dom";
import {urlService} from "../routing/urlsService";
import React from "react";
import OrganizationsPage from "./Organizations/OrganizationsDashboardModule"
import {editOrganization} from "./Organization/edit/EditOrganization";
import {addOrganization} from "./Organization/add/addOrganization";

function OrganizationsModule() {

    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.organizations()} component={OrganizationsPage}/>
                <Route exact path={urlService.editOrganization()} component={editOrganization}/>
                <Route exact path={urlService.addOrganization()} component={addOrganization}/>
            </Switch>
        </Grid>
    )
}


export default OrganizationsModule